<template>
<div>
  <v-snackbar v-model="showError" color="error">
    {{ this.errorText }}
  </v-snackbar>
  <h1 class="my-10">{{$t('app_info.title')}}</h1>
  <v-img :src="images.inkdrops" dark max-height="700px" contain>
  <v-card elevation="10" outlined dark class="mx-auto" min-width="300px" max-width="50%"
    :loading="loggingIn">
    <v-img :src="images.starry_night" dark max-height="500px"
      gradient="to right, rgba(00,00,00,.9), rgba(25,32,72,.80)">
      <v-card-title class="mx-2 my-5 justify-center"> {{ $t('login_form.login') }} </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field class="mx-2" dark
            v-model="userName"
            :disabled="loggingIn"
            autofocus
            :counter="128"
            :type="'text'"
            :rules="userNameRules"
            append-icon="mdi-account-box-outline"
            outlined
            v-bind:label="$t('login_form.userName')" />
          <v-text-field class="mx-2" dark ref="passwordForm"
            v-model="password"
            :disabled="loggingIn"
            :type="'password'"
            :rules="passwordRules"
            outlined
            v-bind:label="$t('login_form.password')"
            append-icon="mdi-key-outline"
            v-on:keyup.enter="login" />
          <v-card-actions class="right d-flex justify-center">
            <v-btn :disabled="loggingIn" class="mx-3" large outlined color="white"
              light @click="login">{{$t('login_form.login_action')}}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-img>
  </v-card>
  </v-img>
</div>

</template>

<script>
import i18n from '@/plugins/i18n'

export default {
  name: 'Login',
  data: () => ({
    loggingIn: false,
    showError: false,
    errorText: '',
    userName: '',
    password: '',
    userNameRules: [
      v => !!v || i18n.t('login_form.login_required')
    ],
    passwordRules: [
      v => !!v || i18n.t('login_form.password_required')
    ],
    images: {
      starry_night: require('../../assets/starry_night.jpg'),
      inkdrops: require('../../assets/inkdrops.png')
    }
  }),
  computed: {
    hasAnyCollection () {
      return this.$store.getters['basicUserInfo/hasAnyCollection']
    }
  },
  methods: {
    async login () {
      if (this.loggingIn || !this.$refs.form.validate()) {
        return
      }
      var loginResult = false
      this.loggingIn = true
      await this.$store.dispatch('authentication/login', { userName: this.userName, password: this.password })
        .then(result => {
          loginResult = true
        },
        error => {
          this.loggingIn = false
          if (error.response.status === 401) {
            this.errorText = i18n.t('login_form.invalid_login_or_password')
          } else {
            this.errorText = i18n.t('login_form.general_error')
          }
          this.showError = true
        })
      if (!loginResult) {
        this.loggingIn = false
        this.$refs.passwordForm.focus()
        return
      }
      this.loginResult = false
      await this.$store.dispatch('basicUserInfo/refreshBasicUserInfo').then(result => {
        if (!this.hasAnyCollection) {
          this.errorText = i18n.t('login_form.no_collection_available')
          this.showError = true
          this.$store.dispatch('authentication/logout')
        }
        this.loginResult = true
      }, _ => {
        this.loggingIn = false
        this.errorText = i18n.t('login_form.refresh_user_data_error')
        this.showError = true
        this.$store.dispatch('authentication/logout')
      })
      if (!loginResult) {
        this.loggingIn = false
        this.$refs.passwordForm.focus()
        return
      }
      await this.$store.dispatch('collectionContext/refreshCollections').then(result => {
        this.loggingIn = false
        this.$router.push('/')
      }, _ => {
        this.loggingIn = false
        this.errorText = i18n.t('login_form.refresh_user_data_error')
        this.showError = true
        this.$store.dispatch('authentication/logout')
        this.$refs.passwordForm.focus()
      })
    }
  }
}
</script>

<style>
h1 {
  font-family: "Oxygen", monospace;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/users/Login.vue